import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';

class OnEnterTrigger extends React.PureComponent {

    static propTypes = {
        element: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.func
        ]),
        onClick: PropTypes.func,
        onTrigger: PropTypes.func,
        disabled: PropTypes.bool,
        disableTabIndex: PropTypes.bool,
        tabIndex: PropTypes.string,
        ariaHidden: PropTypes.string,
        srOnly: PropTypes.string,
        reference: PropTypes.object,
        role: PropTypes.string,
    };

    static defaultProps = {
        element: 'div',
        onClick: _.noop,
        onTrigger: _.noop,
        disabled: false,
        disableTabIndex: false,
        tabIndex: "0",
        ariaHidden: "false",
        srOnly: null,
        reference: null,
        role: 'button',
    };

    focused = false;

    constructor() {
        super();
        this.handleKeyPress = this.handleKeyPress.bind(this);
    }

    UNSAFE_componentWillMount() {
        window.addEventListener('keydown', this.handleKeyPress);
    }

    componentWillUnmount() {
        window.removeEventListener('keydown', this.handleKeyPress);
    }

    handleKeyPress(event) {
        if (this.props.disabled || !this.focused) {
            return;
        }
        if (event.key === 'Enter' || event.key === ' ') {
            event.stopImmediatePropagation();
            event.preventDefault();
            this.props.onClick(event);
            this.props.onTrigger();
        }
    }

    // React bubbles focus, so a focusable descendant would otherwise arm the window keydown
    // listener below and steal Enter from its own control (CORE-22866).
    onFocus = (event) => { this.focused = event.target === event.currentTarget; };

    onBlur = () => { this.focused = false; };

    render () {
        const { element: Element, disabled, disableTabIndex, tabIndex, ariaHidden, srOnly, reference } = this.props;
        const expectedTabIndex = disabled ? -1 : tabIndex;
        const tabIndexProp = disableTabIndex ? null : { tabIndex: expectedTabIndex };

        const srOnlyProps = srOnly ? {'aria-label': srOnly } : null;
        const referenceProps = reference ? { ref: reference } : null;

        return (<Element { ..._.omit(this.props, ['element', 'onTrigger', 'tabIndex', 'ariaHidden', 'disabled', 'srOnly', 'disableTabIndex']) }
                           { ...tabIndexProp }
                           aria-hidden={ ariaHidden }
                           onFocus={ this.onFocus }
                           onBlur={ this.onBlur }
                           { ...referenceProps }
                           { ...srOnlyProps }
                           />);
    }
}

export default OnEnterTrigger;
